// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"470d7ba9","139":"d2f16d68","176":"5052c3d4","369":"08b86454","501":"ccbfd963","535":"7ceebe71","636":"93974926","665":"781aabb6","672":"f87a45a9","694":"87c4a4c5","716":"259091e1","765":"7ed6cc23","867":"150c2c54","903":"c561e87c","966":"30cf62fd"}[chunkId] + ".chunk.js";
};